var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCommunityIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 64,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 64,
  fill: "#E1F6E0",
  rx: 32
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFE040",
  fillRule: "evenodd",
  d: "M26.15 44.709c5.604 0 10.148-3.788 10.148-8.461s-4.544-8.46-10.149-8.46S16 31.574 16 36.247c0 2.162.973 4.135 2.573 5.63L17.966 47l3.958-3.057c1.286.492 2.718.766 4.226.766",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#4690FF",
  fillRule: "evenodd",
  d: "M37.85 44.387c-5.604 0-10.148-3.788-10.148-8.461s4.544-8.461 10.149-8.461S48 31.253 48 35.925c0 2.163-.973 4.136-2.574 5.631l.609 5.122-3.958-3.057a11.8 11.8 0 0 1-4.226.766",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#00B55E",
  fillRule: "evenodd",
  d: "M31.87 19.29c-5.606 0-10.15 3.789-10.15 8.462 0 4.672 4.544 8.46 10.15 8.46 5.605 0 10.149-3.788 10.149-8.46 0-2.163-.973-4.135-2.574-5.631L40.053 17l-3.957 3.057a11.8 11.8 0 0 0-4.227-.766",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#009F18",
  fillRule: "evenodd",
  d: "M36.247 35.387c-.517-4.268-4.84-7.6-10.097-7.6a11.8 11.8 0 0 0-4.377.825c.517 4.269 4.84 7.6 10.097 7.6 1.567 0 3.052-.296 4.377-.825",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#00665E",
  fillRule: "evenodd",
  d: "M42.004 28.204a11.9 11.9 0 0 0-4.153-.74c-5.424 0-9.853 3.547-10.135 8.01 1.268.474 2.674.738 4.153.738 5.424 0 9.853-3.546 10.135-8.009",
  clipRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#467F40",
  fillRule: "evenodd",
  d: "M31.726 29.178c2.754 1.513 4.572 4.115 4.572 7.07 0 2.755-1.58 5.203-4.025 6.748-2.754-1.513-4.572-4.115-4.572-7.07 0-2.755 1.58-5.203 4.025-6.748",
  clipRule: "evenodd"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#005A18",
  fillRule: "evenodd",
  d: "M36.246 35.387c-.314-2.595-2.036-4.844-4.52-6.209-2.31 1.46-3.848 3.726-4.01 6.296a11.9 11.9 0 0 0 4.153.739 11.8 11.8 0 0 0 4.377-.826",
  clipRule: "evenodd"
})));
export default SvgCommunityIcon;